/* unplugin-vue-components disabled */import { render } from "./Footer.vue?vue&type=template&id=5f366a90&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=5f366a90&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-案例中心-前台页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f366a90"]])

export default __exports__